import React from 'react';
import PropTypes from 'prop-types';
import { icons } from 'smartsuite-ui';

const sortOrders = {
    asc: 'asc',
    desc: 'desc',
};

function isValidSortObject(sortObject) {
    return !!sortObject && !!sortObject.sortOrder && !!sortObject.columnName;
}

function isCurrentColumnSorted(sortObject, columnName) {
    return sortObject.columnName === columnName;
}

function isValidSortOrder(sortObject) {
    return !!sortOrders[sortObject.sortOrder];
}

// eslint-disable-next-line complexity
function sort({ sortObject = {}, columnName = '', onSort }) {
    if (!sortObject || sortObject.columnName !== columnName) {
        onSort({
            columnName,
            sortOrder: sortOrders.asc,
        });
        return;
    }

    if (sortObject.sortOrder === sortOrders.asc) {
        onSort({
            columnName,
            sortOrder: sortOrders.desc,
        });
        return;
    }

    onSort(null);
}

function columnIsSorted(sortObject, columnName) {
    return (
        isValidSortObject(sortObject) &&
        isCurrentColumnSorted(sortObject, columnName) &&
        isValidSortOrder(sortObject)
    );
}

function renderSortIndicator(sortObject, columnName) {
    const iconBaseClass = 'table-header-cell__sort-icon';

    if (!columnIsSorted(sortObject, columnName)) {
        return (
            <span
                className={`${iconBaseClass} ${iconBaseClass}--not-sorted ${icons.sort}`}
            />
        );
    }

    return (
        <span className={`${iconBaseClass} ${icons[sortObject.sortOrder]}`} />
    );
}

export function TableHeaderCellSortable(props) {
    const {
        children,
        sortObject,
        columnName,
        onSort,
        renderDraggableIcon,
        ...remainingProps
    } = props;
    return (
        <th
            {...remainingProps}
            className="table-header-cell table-header-cell--sortable"
            onClick={(event) => {
                if (event.target.classList.contains('DragHandle')) {
                    return;
                }
                sort(props);
            }}
        >
            <span className="table-header-cell__sort-text">{children}</span>
            {renderSortIndicator(sortObject, columnName)}
            {renderDraggableIcon(columnName)}
        </th>
    );
}

TableHeaderCellSortable.propTypes = {
    columnName: PropTypes.string.isRequired,
    onSort: PropTypes.func.isRequired,
    children: PropTypes.node,
    sortObject: PropTypes.shape({
        columnName: PropTypes.string,
        sortOrder: PropTypes.string,
    }),
    renderDraggableIcon: PropTypes.func.isRequired,
};

TableHeaderCellSortable.defaultProps = {
    children: null,
    sortObject: null,
};
